import { render } from "./TASK_READINESS_NOTIFICATION.vue?vue&type=template&id=511cc158&ts=true"
import script from "./TASK_READINESS_NOTIFICATION.vue?vue&type=script&lang=ts"
export * from "./TASK_READINESS_NOTIFICATION.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__